import Controller from '@ember/controller';

/*
types:
  project
  freelancer
  invoice
 */
class ReportsController extends Controller {
  type = 'project';
  year = new Date().getFullYear();

  get queryParams() {
    return ['type', 'year'];
  }
}

export default ReportsController
